import React from 'react';

export interface DashboardTabItem {
  key: string;
  label: string;
}

interface DashboardTabsProps {
  tabs: DashboardTabItem[];
  active: string;
  onChange: (key: string) => void;
}

export const DashboardTabs: React.FC<DashboardTabsProps> = ({ tabs, active, onChange }) => {
  return (
    <div className="rounded-2xl border border-slate-200/80 bg-white p-2 shadow-[0_10px_30px_-22px_rgba(15,23,42,0.35)]">
      <div className="flex gap-2 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={`whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-bold transition ${
              active === tab.key ? 'border border-[#C8D6FF] bg-[#EEF4FF] text-[#1C3B9B] shadow-[0_10px_22px_-16px_rgba(28,59,155,0.45)]' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
